import React from 'react';
import SectionHeader from './SectionHeader';
import StatCard from './StatCard';
import PricingCard from './PricingCard';
import SnookerGallery from './SnookerGallery';
import CoachingBanner from './CoachingBanner';

interface GalleryImage {
  src: string;
  alt: string;
}

interface SnookerSectionProps {
  showGallery?: boolean;
  showCoachingBanner?: boolean;
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  snookerTables?: string;
  poolTables?: string;
  tableType?: 'snooker' | 'pool' | 'both';
  galleryImages?: GalleryImage[];
}

const SnookerSection: React.FC<SnookerSectionProps> = ({ 
  showGallery = false,
  showCoachingBanner = false,
  eyebrow = "SNOOKER & POOL",
  title = "Snooker Hall",
  subtitle = "We have 10 full-size snooker tables available for hire — whether you're a casual player or a serious competitor we have the right table for you.",
  snookerTables = "10",
  poolTables = "8",
  tableType = 'both',
  galleryImages = []
}) => {
  return (
    <section id="snooker" className="py-20 bg-gradient-to-b from-primary-black via-snooker-green to-primary-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow={eyebrow}
          title={title}
          subtitle={subtitle}
          darkMode={true}
        />

        {showGallery && galleryImages.length > 0 && <SnookerGallery images={galleryImages} />}

        {showCoachingBanner && (
          <div className="my-12">
            <CoachingBanner />
          </div>
        )}

        {/* Stats Cards */}
        <div className={`grid grid-cols-2 gap-6 mb-16 ${tableType === 'both' ? 'md:grid-cols-4' : 'md:grid-cols-3'}`}>
          {(tableType === 'snooker' || tableType === 'both') && (
            <StatCard
              value={snookerTables}
              label="Snooker Tables"
              sublabel=""
            />
          )}
          {(tableType === 'pool' || tableType === 'both') && (
            <StatCard
              value={poolTables}
              label="Pool Tables"
              sublabel=""
            />
          )}
          <StatCard
            value="7 Days"
            label="Open Every Week"
            sublabel=""
          />
          <StatCard
            value="All Levels"
            label="Welcome"
            sublabel=""
          />
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <PricingCard
            title="Non-Members"
            duration=""
            price="£11"
            priceUnit="/hour"
            features={[
              "Pool: £11/hour",
              "Snooker: £11/hour"
            ]}
          />
          
          <PricingCard
            title="Become a Member"
            duration="Only £24 for the year!"
            price="£24"
            priceUnit=""
            features={[
              "10% off when playing with a non-member",
              "20% off when everyone's a member",
              "30% off when playing solo"
            ]}
            isPopular={true}
          />
          
          <PricingCard
            title="Member Deals You Can't Beat"
            duration=""
            price="£15"
            priceUnit=""
            features={[
              "2 hours for £15",
              "4 hours for £28"
            ]}
          />
        </div>

        
      </div>
    </section>
  );
};

export default SnookerSection;
